"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AudioComponent = ({ audioElement, label }) => {
    return (react_1.default.createElement("audio", { ref: audioElement },
        react_1.default.createElement("track", { kind: "captions", label: label }),
        `Your browser does not support the
        <code>audio</code>
        element.`));
};
exports.default = AudioComponent;
